var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form holiday-search",
      attrs: { action: _vm.action, role: "search" },
      on: { submit: _vm.submit },
    },
    [
      _c(
        "div",
        {
          staticClass: "holiday-search__term-wrapper",
          class: {
            "blure-effect": _vm.openWhen || _vm.openHow || _vm.openDepartures,
          },
        },
        [
          _c(
            "label",
            {
              staticClass: "visually-hidden",
              attrs: { for: _vm.field("holiday-where") },
            },
            [_vm._v("\n      " + _vm._s(_vm.whereDescription) + "\n    ")]
          ),
          _vm._v(" "),
          _c("input", {
            staticClass: "holiday-search__term",
            attrs: {
              id: _vm.field("holiday-where"),
              name: _vm.whereType,
              placeholder: _vm.isClicked
                ? _vm.onclickPlaceholder
                : _vm.whereDescription,
              type: "text",
              autocomplete: "off",
            },
            domProps: { value: _vm.where },
            on: {
              input: _vm.onInput,
              blur: _vm.handleBlur,
              click: function ($event) {
                $event.stopPropagation()
                return _vm.openAutoComplete.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _vm.autoCompleteOpen && _vm.suggestions.length
            ? _c(
                "div",
                {
                  staticClass: "holiday-search__autocomplete",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                _vm._l(_vm.suggestions, function (section, sectionIndex) {
                  return _c(
                    "div",
                    {
                      key: section.title + sectionIndex,
                      staticClass: "holiday-search__autocomplete-section",
                    },
                    [
                      _c(
                        "h4",
                        { staticClass: "holiday-search__autocomplete-title" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(section.title) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "holiday-search__autocomplete-list" },
                        _vm._l(
                          section.items,
                          function (suggestion, suggestionIndex) {
                            return _c(
                              "li",
                              {
                                key:
                                  section.title +
                                  suggestion.name +
                                  suggestionIndex,
                                staticClass:
                                  "holiday-search__autocomplete-item",
                              },
                              [
                                suggestion.url
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "holiday-search__autocomplete-link",
                                        attrs: {
                                          href: suggestion.url,
                                          "aria-label":
                                            "Go to " + suggestion.name,
                                          title:
                                            "Click to view more details about " +
                                            suggestion.name,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(suggestion.name) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass:
                                          "holiday-search__autocomplete-button",
                                        attrs: {
                                          type: "button",
                                          "aria-label":
                                            "Select autocomplete suggestion",
                                          titlel:
                                            "Select autocomplete suggestion",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setWhereFromAutoComplete(
                                              suggestion.name,
                                              section.type
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(suggestion.name) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "holiday-search__term-wrapper",
          class: {
            "blure-effect":
              _vm.openHow || _vm.openDepartures || _vm.autoCompleteOpen,
          },
        },
        [
          _c(
            "label",
            {
              staticClass: "visually-hidden",
              attrs: { for: _vm.field("holiday-when") },
            },
            [_vm._v("\n      " + _vm._s(_vm.whenDescription) + "\n    ")]
          ),
          _vm._v(" "),
          _c("input", {
            ref: "WhenDropdownInput",
            staticClass: "holiday-search__term",
            class: { "blure-effect": _vm.openWhen },
            attrs: {
              id: _vm.field("select-when"),
              type: "text",
              placeholder: _vm.whenDescription,
              autocomplete: "off",
              readonly: "",
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.toggleWhen.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _c("DatePicker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.openWhen,
                expression: "openWhen",
              },
            ],
            attrs: { items: _vm.dates, label: "When", name: "Dates" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "holiday-search__term-wrapper",
          class: {
            "blure-effect":
              _vm.openWhen || _vm.openDepartures || _vm.autoCompleteOpen,
          },
        },
        [
          _c(
            "label",
            {
              staticClass: "visually-hidden",
              attrs: { for: _vm.field("holiday-how") },
            },
            [_vm._v("\n      " + _vm._s(_vm.travelStyleDescription) + "\n    ")]
          ),
          _vm._v(" "),
          _c("input", {
            ref: "HowDropdownInput",
            staticClass: "holiday-search__term",
            attrs: {
              id: _vm.field("select-how"),
              type: "text",
              placeholder: _vm.travelStyleDescription,
              autocomplete: "off",
              readonly: "",
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.toggleHow.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _c("Dropdown", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.openHow,
                expression: "openHow",
              },
            ],
            attrs: { items: _vm.types, label: "How", name: "Types" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showDepartureFilter
        ? _c(
            "div",
            {
              staticClass: "holiday-search__term-wrapper",
              class: {
                "blure-effect":
                  _vm.openWhen || _vm.openHow || _vm.autoCompleteOpen,
              },
            },
            [
              _c(
                "label",
                {
                  staticClass: "visually-hidden",
                  attrs: { for: _vm.field("select-departures") },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.departureDescription) + "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                ref: "DeparturesDropdownInput",
                staticClass: "holiday-search__term",
                attrs: {
                  id: _vm.field("select-departures"),
                  type: "text",
                  placeholder: _vm.departureDescription,
                  autocomplete: "off",
                  readonly: "",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.toggleDepartures.apply(null, arguments)
                  },
                },
              }),
              _vm._v(" "),
              _c("Dropdown", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.openDepartures,
                    expression: "openDepartures",
                  },
                ],
                attrs: {
                  items: _vm.departures,
                  label: "Departures",
                  name: "Departs",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        staticClass: "btn holiday-search__btn border-radius-none uppercase",
        class: {
          "blure-effect":
            _vm.openWhen ||
            _vm.openHow ||
            _vm.openDepartures ||
            _vm.autoCompleteOpen,
        },
        attrs: { type: "submit", value: "Find my holiday" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }